import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";
import { PlanFeatureList } from "~/components/PlanFeatures";

interface FreePlanCardProps {
  /** アクションボタン領域 */
  action: React.ReactNode;
  /** バッジ（"Default" / "Current Plan" 等） */
  badge?: React.ReactNode;
  /** カードのボーダー色クラス（デフォルト: border-blue-500） */
  borderClassName?: string;
}

export function FreePlanCard({ action, badge, borderClassName = "border-blue-500" }: FreePlanCardProps) {
  return (
    <Card className={`border-2 ${borderClassName} flex flex-col`}>
      <CardHeader>
        <div className="flex justify-between items-start mb-2">
          <CardTitle className="text-3xl">Free</CardTitle>
          {badge}
        </div>
        <CardDescription className="text-2xl font-bold text-gray-900">
          $0<span className="text-base font-normal text-gray-500">/month</span>
          {/* Deep Dive Annual の2行目に合わせて高さを固定 */}
          <div className="invisible text-sm font-normal mt-1">placeholder</div>
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 flex-1 flex flex-col">
        <div className="text-left flex-1">
          <PlanFeatureList planType="free" />
        </div>
        {action}
      </CardContent>
    </Card>
  );
}
